import { CommentEndpoints } from 'src/client/comment/constants'
import useRequest from 'src/hook/useRequest'
import { getCommentAudio } from 'src/client/Comments'
import { DEFAULT_AUDIO_CACHE_TIME } from 'src/config/request'
import { Loading } from 'src/components'
import styled from 'styled-components'
import { useUser } from 'src/hook/useUser'
import { ThemeMode } from '@hotmart/space-lib/dist/styles/themes/enum'

export type AudioPreviewProps = {
  commentId: number
}

const CustomAudio = styled.audio<{ theme: string }>`
  ::-webkit-media-controls-enclosure {
    background-color: var(--gray-200);
  }

  ::-webkit-media-controls-panel {
    filter: ${({ theme }) => (theme === ThemeMode.DARK ? 'invert(1)' : 'none')};
  }
`

const CustomAudioPreview = styled.div`
  margin-top: 0.375rem;
`

const AudioPreview = ({ commentId }: AudioPreviewProps) => {
  const { theme } = useUser()
  const { data: commentMediaSrc, isLoading: isLoadingMedia } = useRequest(
    `${CommentEndpoints.getCommentAudio(commentId)}`,
    /* istanbul ignore next */
    () => getCommentAudio(commentId),
    {
      cacheTime: DEFAULT_AUDIO_CACHE_TIME
    }
  )

  return (
    <CustomAudioPreview data-test="audio-preview">
      {isLoadingMedia ? (
        <div className="_w-full _d-flex _align-items-center _justify-content-center">
          <Loading />
        </div>
      ) : (
        <CustomAudio controls theme={theme}>
          <source src={commentMediaSrc} type="audio/mp4" />
        </CustomAudio>
      )}
    </CustomAudioPreview>
  )
}

export default AudioPreview
